import { useAsync } from 'react-use';
import { captureException } from '@sentry/browser';

import { MastheadResponseType } from 'etc/types';
import { useIsPlainPage } from 'context/PlainPage/plainPage';

const MASTHEAD_API = 'https://www.spotify.com/api/masthead/v1/masthead';

export const useMastHead = (market: string) => {
  const isPlainPage = useIsPlainPage();
  const {
    value,
    loading: isLoading,
    error,
  } = useAsync(async (): Promise<MastheadResponseType | undefined> => {
    if (isPlainPage) {
      return undefined;
    }

    const queryParams = new URLSearchParams({
      market,
    });

    try {
      const response = await fetch(`${MASTHEAD_API}?${queryParams}`, {
        credentials: 'include',
      });
      if (response.ok) {
        const masthead: MastheadResponseType = await response.json();
        return masthead;
      }

      captureException(`Error when fetching masthead data, got: ${response.status}`);
      throw new Error('');
    } catch (e: unknown) {
      captureException(e);
      throw new Error('');
    }
  }, []);

  return {
    isLoading,
    error,
    header: value?.header,
    footer: value?.footer,
  };
};

export default useMastHead;
